var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBlocked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.26349 33.4131L7.26349 25.9131C7.26349 25.4158 7.46103 24.9389 7.81266 24.5873C8.16429 24.2356 8.64121 24.0381 9.13849 24.0381L50.3885 24.0381C50.8858 24.0381 51.3627 24.2356 51.7143 24.5873C52.0659 24.9389 52.2635 25.4158 52.2635 25.9131V33.4131C52.2635 33.9104 52.0659 34.3873 51.7143 34.7389C51.3627 35.0905 50.8858 35.2881 50.3885 35.2881H9.13849C8.64121 35.2881 8.16429 35.0905 7.81266 34.7389C7.46103 34.3873 7.26349 33.9104 7.26349 33.4131Z",
    fill: "url(#paint0_linear_970_16595)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7635 0.600586C13.7088 0.600586 0.700989 13.6084 0.700989 29.6631C0.700989 45.7178 13.7088 58.7256 29.7635 58.7256C45.8182 58.7256 58.826 45.7178 58.826 29.6631C58.826 13.6084 45.8182 0.600586 29.7635 0.600586ZM50.3885 35.2881H9.13849C8.64121 35.2881 8.16429 35.0905 7.81266 34.7389C7.46103 34.3873 7.26349 33.9104 7.26349 33.4131V25.9131C7.26349 25.4158 7.46103 24.9389 7.81266 24.5873C8.16429 24.2356 8.64121 24.0381 9.13849 24.0381L50.3885 24.0381C50.8858 24.0381 51.3627 24.2356 51.7143 24.5873C52.0659 24.9389 52.2635 25.4158 52.2635 25.9131V33.4131C52.2635 33.9104 52.0659 34.3873 51.7143 34.7389C51.3627 35.0905 50.8858 35.2881 50.3885 35.2881Z",
    fill: "url(#paint1_linear_970_16595)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_970_16595",
    x1: 29.7635,
    y1: 24.0381,
    x2: 29.7635,
    y2: 35.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_970_16595",
    x1: 29.7635,
    y1: 0.600586,
    x2: 29.7635,
    y2: 58.7256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgBlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blocked.0f8ec91d339a4ed4dc9764adf70a3d2c.svg";